var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24512 2.375H9.18262C9.26595 2.375 9.30762 2.41667 9.30762 2.5V13.5C9.30762 13.5833 9.26595 13.625 9.18262 13.625H8.24512C8.16178 13.625 8.12012 13.5833 8.12012 13.5V2.5C8.12012 2.41667 8.16178 2.375 8.24512 2.375Z",
    fill: "#0070BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46387 7.40625H13.9639C14.0472 7.40625 14.0889 7.44792 14.0889 7.53125V8.46875C14.0889 8.55208 14.0472 8.59375 13.9639 8.59375H3.46387C3.38053 8.59375 3.33887 8.55208 3.33887 8.46875V7.53125C3.33887 7.44792 3.38053 7.40625 3.46387 7.40625Z",
    fill: "#0070BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonUpload);
export default __webpack_public_path__ + "static/media/ButtonUpload.2514e223cb4e167d5e553f0e0fd711cf.svg";
export { ForwardRef as ReactComponent };